<template>
  <div class="product">
    <div class="product__image skeleton"></div>
    <div class="product__info">
      <span class="product__title skeleton"></span>
      <span class="add-to-bag__button skeleton"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkeletonProductTile",
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/skeleton";

.product {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product__image {
  padding-bottom: 150%;
}

.product__info {
  padding: 10px 10px 40px 10px;
}

.product__title {
  display: block;
  height: 15px;
  width: 75%;
}

.add-to-bag__button {
  display: block;
  height: 11px;
  width: 70%;
  margin-top: 10px;
}
</style>
